<template>
  <div class="adminSixtenDashborad">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="row text-center">
            <div class="col">
              <H1>Gestione Spedizioni</H1>
            </div>
          </div>
          <div class="row">&nbsp;</div>
          <div class="row">
            <div class="col text-center">
              <router-link to="/admin/picking/OCList">
                <button class="btn btn-success btn-block">
                  <i class="nav-icon fa fa-file-image-o"></i> Lista OC
                </button>
              </router-link>
            </div>
          </div>
          <div class="row">&nbsp;</div>
          <div class="row">
            <div class="col text-center">
              <router-link to="/admin/picking/reading">
                <button class="btn btn-primary btn-block">
                  <i class="fa fa-barcode"></i> Avvia lettura
                </button>
              </router-link>
            </div>
          </div>
          <div class="row">&nbsp;</div>
          <div class="row">
            <div class="col text-center">
              <router-link to="/admin/shipment/sentSixten">
                <button class="btn btn-warning btn-block">
                  <i class="fa fa-paper-plane-o"></i> Spedisci
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "adminSixtenDashborad"
};
</script>

<style>
@media (min-width: 992px) {
  .btn-block {
    display: inline-block;
    width: auto;
    margin-top: 0rem !important;
  }
}
</style>
